"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareDialog = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const dialog_1 = require("../../components/dialog/dialog");
const detail_context_1 = require("../detail/detail-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tooltip_1 = require("../../components/tooltip/tooltip");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
exports.ShareDialog = react_1.forwardRef(function ShareDialog({ onCancel }, ref) {
    const inputRef = react_1.useRef(null);
    const intl = react_intl_1.useIntl();
    const route = react_router_dom_1.useRouteMatch();
    const { source } = react_1.useContext(detail_context_1.DetailContext);
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const handleFocus = event_callback_hook_1.useEventCallback((e) => {
        e.preventDefault();
        if (inputRef.current) {
            const last = inputRef.current.value.length;
            inputRef.current.focus();
            inputRef.current.setSelectionRange(0, last);
        }
    });
    const handleCopy = event_callback_hook_1.useEventCallback((e) => {
        e.preventDefault();
        if (inputRef.current) {
            handleFocus(e);
            document.execCommand('copy');
            const message = intl.formatMessage({
                id: 'EAS_DETAIL_SHARE_DIALOG_MSG_SUCCESS',
                defaultMessage: 'Odkaz jste úspěšně zkopírovali',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
        }
    });
    const title = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_SHARE_DIALOG_TITLE", defaultMessage: "Z\u00EDskat odkaz" }));
    const text = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_SHARE_DIALOG_TEXT", defaultMessage: "Sd\u00EDlet s ostatn\u00EDmi:" }));
    const copyTooltip = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_SHARE_DIALOG_COPY_BUTTON", defaultMessage: "Kop\u00EDrovat" }));
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: title, showConfirm: false, onCancel: onCancel }, () => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { style: { width: 900 } }, text),
            react_1.default.createElement("br", null),
            ((_a = source.data) === null || _a === void 0 ? void 0 : _a.id) && (react_1.default.createElement(TextField_1.default, { variant: "outlined", fullWidth: true, onClick: handleFocus, value: `${window.location.origin}${route.path.replace(':id?', source.data.id)}`, inputRef: inputRef, InputProps: {
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                        react_1.default.createElement(IconButton_1.default, { "aria-label": "copy", onClick: handleCopy, edge: "end" },
                            react_1.default.createElement(tooltip_1.Tooltip, { title: copyTooltip, placement: "right" },
                                react_1.default.createElement(FileCopy_1.default, null))))),
                } }))));
    }));
});
//# sourceMappingURL=share-dialog.js.map